"use strict";
var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
var _SelectionParameter_parameterManager, _SelectionParameter_sessionEngineCore;
Object.defineProperty(exports, "__esModule", { value: true });
exports.SelectionParameter = void 0;
const viewer_shared_types_1 = require("@shapediver/viewer.shared.types");
const Parameter_1 = require("../Parameter");
class SelectionParameter extends Parameter_1.Parameter {
    constructor(paramDef, sessionEngineCore, parameterManager) {
        super(paramDef, sessionEngineCore, parameterManager);
        _SelectionParameter_parameterManager.set(this, void 0);
        _SelectionParameter_sessionEngineCore.set(this, void 0);
        __classPrivateFieldSet(this, _SelectionParameter_sessionEngineCore, sessionEngineCore, "f");
        __classPrivateFieldSet(this, _SelectionParameter_parameterManager, parameterManager, "f");
    }
    get hover() {
        var _a;
        return (_a = this.getSelectionProperties()) === null || _a === void 0 ? void 0 : _a.hover;
    }
    get interactionType() {
        return "selection";
    }
    get maximumSelection() {
        var _a;
        return (_a = this.getSelectionProperties()) === null || _a === void 0 ? void 0 : _a.maximumSelection;
    }
    get minimumSelection() {
        var _a;
        return (_a = this.getSelectionProperties()) === null || _a === void 0 ? void 0 : _a.minimumSelection;
    }
    get nameFilter() {
        var _a;
        return (_a = this.getSelectionProperties()) === null || _a === void 0 ? void 0 : _a.nameFilter;
    }
    get selectionColor() {
        var _a;
        return (_a = this.getSelectionProperties()) === null || _a === void 0 ? void 0 : _a.selectionColor;
    }
    getSelectionProperties() {
        const result = (0, viewer_shared_types_1.validateSelectionParameterSettings)(this.settings);
        if (result.success) {
            return this.settings
                .props;
        }
    }
}
exports.SelectionParameter = SelectionParameter;
_SelectionParameter_parameterManager = new WeakMap(), _SelectionParameter_sessionEngineCore = new WeakMap();
//# sourceMappingURL=SelectionParameter.js.map